import React, {Fragment} from "react"
import {Button, Checkbox, Divider, Form, Input, InputNumber, Radio, Select, Typography,} from "antd";
import {EuroOutlined} from "@ant-design/icons"
import {getCurrencyFormater, getDeviseSymbol} from "../../i18n";

import {t} from "@lingui/core/macro"

const {Text}=Typography

export default class Campagne extends React.Component{

    render()
    {
        const {config,context,devise,disabled}=this.props

        const fixedNbMonth=config?.fixedNbMonth || false
        const fixedProducts=config?.fixedProducts || false
        const currencyFormater=getCurrencyFormater(context)
        if(config.checkoutId){
            const value=config.nbMonth || 0
            return (
                <div style={{display:"flex",flexDirection:"column",alignItems:"center",paddingBlock:20,gap:10}}>
                    <Form.Item label={config.abo ? t`Montant par mois` : t`Montant`} name="montant" rules={[{required:true,message:t`Ce champ est obligatoire`}]}>
                        <InputNumber size="large" readOnly addonAfter={getDeviseSymbol(context,devise)} />
                    </Form.Item>
                    {config.abo && <Text>{value ? t`Pendant ${value} mois` : t`En continue - résiliable à tout moment`}</Text>}
                    <Form.Item name="abo" hidden><Input /></Form.Item>
                    <Form.Item name="nbMonth" hidden><Input /></Form.Item>
                </div>
            )
        }

        // Campagne réglée pour présenter les dons étalés en mensualité : la page de paiement
        // raisonne en abonnement (montant par mois + durée) et non en total à diviser.
        // index.js convertit un étalement choisi en amont (total ÷ nb de mois) à l'arrivée.
        const maxDivide = config?.maxDivide || 12
        if (config?.monthlyAmountDisplay && config?.nbMonth === undefined && maxDivide !== 1) {
            return (
                <div style={{display: "flex", alignItems: "center", flexDirection: "column", padding: "20px 10%"}}>
                    <Form.Item noStyle shouldUpdate>
                        {(e) => {
                            const nbMonth = parseInt(e.getFieldValue("nbMonth")) || 0
                            return (
                                <Fragment>
                                    <Form.Item
                                        label={nbMonth > 1 ? t`Montant par mois` : t`Montant`}
                                        name="montant"
                                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                    >
                                        <InputNumber size="large" min={1} placeholder={t`Montant`} addonAfter={getDeviseSymbol(context,devise)}
                                                     disabled={disabled || fixedProducts} readOnly={fixedProducts}/>
                                    </Form.Item>

                                    <Form.Item name={"nbMonth"} style={{width: "100%"}}>
                                        <select disabled={disabled} className={"form-control"} style={{width: "100%"}}
                                                onChange={(ev) => {
                                                    // Produits imposés : le total est fixé, c'est la mensualité qui suit la durée.
                                                    if (!fixedProducts) {
                                                        return
                                                    }
                                                    const nb = parseInt(ev.target.value) || 0
                                                    const total = Number(config?.montant) || 0
                                                    e.setFieldValue("montant", nb > 1 ? Math.ceil(total / nb) : total)
                                                }}>
                                            <option value={0}>{t`Donner en une seule fois`}</option>
                                            {Array.from(Array(maxDivide - 1).keys()).map((i) => {
                                                const value = i + 2
                                                return <option key={value} value={value}>{t`Chaque mois pendant ${value} mois`}</option>
                                            }).reverse()}
                                        </select>
                                    </Form.Item>
                                </Fragment>
                            )
                        }}
                    </Form.Item>
                </div>
            )
        }

        return (
            <div style={{display: "flex", alignItems: "center", flexDirection: "column", padding: "20px 10%"}}>

                <Form.Item
                    label={t`Montant`}
                    name="montant"
                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                >
                    <InputNumber size="large" min={1} placeholder={t`Montant`} addonAfter={getDeviseSymbol(context,devise)}
                                 disabled={disabled || fixedNbMonth || fixedProducts} readOnly={fixedNbMonth || fixedProducts}/>
                </Form.Item>

                <Form.Item noStyle shouldUpdate>
                    {(e) => {

                        let maxNbMonth = config?.maxNbMonth || 12
                        let minNbMonth = config?.minNbMonth || null

                        const montant = e.getFieldValue("montant")

                        if (config?.nbMonth === undefined && montant < maxDivide) {
                            return null
                        }

                        return (
                            <Fragment>

                                {config?.nbMonth !== undefined && (
                                    <Fragment>
                                        <Form.Item noStyle name={"abo"} hidden>
                                            <Input type={"hidden"} value={true}/>
                                        </Form.Item>

                                        <Form.Item name={"nbMonth"} style={{width: "100%"}}>
                                            <select className={"form-control"}
                                                    style={{width: "100%", marginBottom: 10, marginTop: -10}}
                                                    disabled={disabled || fixedNbMonth}>
                                                <option value={0}>{t`En continue - résiliable à tout moment`}</option>
                                                {Array.from(Array(maxNbMonth - 1).keys()).map((i) => {
                                                    const value=i + 2
                                                    if(minNbMonth && minNbMonth>value){
                                                        return null
                                                    }
                                                    return <option key={i} value={value}>{t`Pendant ${value} mois`}</option>
                                                }).reverse()}
                                            </select>
                                        </Form.Item>
                                    </Fragment>
                                )}

                                {config?.nbMonth === undefined && maxDivide!==1 && (
                                    <Form.Item name={"divide"} style={{width: "100%"}}>
                                        <select disabled={disabled} className={"form-control"} style={{width: "100%"}}>
                                            <option value={0}>{t`Ne pas diviser mon don`}</option>
                                            {Array.from(Array(maxDivide - 1).keys()).map((i) => {
                                                const value = i + 2
                                                // Arrondi au supérieur : c'est la mensualité réellement prélevée (cf. index.js).
                                                return <option key={value}
                                                    value={value}>{t`Diviser mon don sur ${value} mois soit (${currencyFormater(Math.ceil(montant / value),0,devise)}/mois)`}</option>
                                            })}
                                        </select>
                                    </Form.Item>
                                )}
                            </Fragment>
                        )
                    }}
                </Form.Item>
            </div>
        )
    }
}
